(() => {
  const lockScroll = () => {
    document.documentElement.classList.add('is-scroll-locked');
    document.body.classList.add('is-scroll-locked');
  };

  const unlockScroll = () => {
    document.documentElement.classList.remove('is-scroll-locked');
    document.body.classList.remove('is-scroll-locked');
  };

  const initMenu = () => {
    const drawer = document.querySelector('[data-ak-menu]');
    const toggle = document.querySelector('[data-ak-menu-toggle]');
    if (!drawer || !toggle) return;

    const open = () => {
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      lockScroll();
    };

    const close = () => {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      unlockScroll();
    };

    toggle.addEventListener('click', () => {
      drawer.classList.contains('is-open') ? close() : open();
    });

    drawer.querySelectorAll('[data-ak-menu-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  };

  const initReveals = () => {
    const items = document.querySelectorAll('.ak-reveal, .ak-card, .ak-story, .ak-lineup, .ak-shop-lead');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );

    items.forEach((item) => observer.observe(item));
  };

  const initProductMedia = () => {
    document.querySelectorAll('[data-ak-product-media]').forEach((media) => {
      const mainImage = media.querySelector('.ak-product__main-image');
      if (!mainImage) return;

      media.querySelectorAll('.ak-product__thumbs a').forEach((thumb) => {
        thumb.addEventListener('click', (event) => {
          event.preventDefault();
          mainImage.src = thumb.href;
          mainImage.removeAttribute('srcset');
          const thumbImage = thumb.querySelector('img');
          if (thumbImage?.alt) mainImage.alt = thumbImage.alt;
        });
      });
    });
  };

  const initProductOptions = () => {
    document.querySelectorAll('.ak-product__form').forEach((form) => {
      const variantsScript = form.querySelector('[data-ak-variants]');
      const variantIdInput = form.querySelector('[data-ak-variant-id]');
      if (!variantsScript || !variantIdInput) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent || '[]');
      } catch {
        return;
      }

      const sync = () => {
        const selected = Array.from(form.querySelectorAll('.ak-product__option')).map((fieldset) => {
          const checked = fieldset.querySelector('input[type="radio"]:checked');
          return checked?.value || '';
        });

        const match = variants.find((variant) => selected.every((value, index) => variant.options?.[index] === value));
        if (!match) return;

        variantIdInput.value = match.id;
        const submit = form.querySelector('button[type="submit"]');
        if (submit) submit.disabled = !match.available;
      };

      form.querySelectorAll('[data-ak-option]').forEach((input) => input.addEventListener('change', sync));
      sync();
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initMenu();
    initReveals();
    initProductMedia();
    initProductOptions();
  });
})();

(() => {
  const moneyFormat = (cents) => {
    const amount = Number(cents || 0) / 100;
    return `Rs. ${amount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const escapeHtml = (value) =>
    String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[char]);

  const initAliceMenu = () => {
    const drawer = document.querySelector('[data-menu-drawer]');
    const toggle = document.querySelector('[data-menu-toggle]');
    if (!drawer || !toggle) return;

    const open = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('theme-menu-open');
    };

    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('theme-menu-open');
    };

    toggle.addEventListener('click', () => (drawer.classList.contains('is-open') ? close() : open()));
    drawer.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', close));
  };

  const initAliceSearch = () => {
    const drawer = document.querySelector('[data-search-drawer]');
    if (!drawer) return;

    const header = document.querySelector('[data-theme-header]');
    const inlineForm = document.querySelector('[data-header-search-form]');
    const inlineInput = document.querySelector('[data-header-search-input]');
    const input = drawer.querySelector('[data-search-input]');
    const form = drawer.querySelector('[data-search-form]');
    const results = drawer.querySelector('[data-search-results]');
    let searchTimer = null;
    const desktopSearch = window.matchMedia('(min-width: 741px)');

    const closeMenu = () => {
      const menu = document.querySelector('[data-menu-drawer]');
      const menuToggle = document.querySelector('[data-menu-toggle]');
      if (!menu) return;
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      menuToggle?.setAttribute('aria-expanded', 'false');
    };

    const open = () => {
      if (desktopSearch.matches && inlineForm && inlineInput) {
        closeMenu();
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('theme-search-open');
        header?.classList.add('is-searching');
        inlineForm.setAttribute('aria-hidden', 'false');
        window.setTimeout(() => inlineInput.focus(), 40);
        return;
      }
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('theme-search-open');
      window.setTimeout(() => input?.focus(), 60);
    };

    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('theme-search-open');
      header?.classList.remove('is-searching');
      inlineForm?.setAttribute('aria-hidden', 'true');
    };

    const renderProducts = (products, query) => {
      if (!results) return;

      if (!query) {
        results.innerHTML = '<p class="theme-search__empty">Search earrings, pendants, rings, bracelets and necklaces.</p>';
        return;
      }

      if (!products.length) {
        results.innerHTML = '<p class="theme-search__empty">No products found. Try a different Alice Meyers piece.</p>';
        return;
      }

      results.innerHTML = products.map((product) => {
        const image = product.image || product.featured_image || {};
        const imageUrl = typeof image === 'string' ? image : image.url || image.src || '';
        const price = product.price ? moneyFormat(product.price) : '';
        return `
          <a class="theme-search__result" href="${product.url}">
            ${imageUrl ? `<img src="${imageUrl}" alt="${escapeHtml(product.title)}" loading="lazy">` : '<span></span>'}
            <strong>${escapeHtml(product.title)}</strong>
            <span>${price}</span>
          </a>
        `;
      }).join('');
    };

    const fetchSuggestions = async (query) => {
      const cleanQuery = query.trim();
      if (!cleanQuery) {
        renderProducts([], '');
        return;
      }

      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(cleanQuery)}&resources[type]=product&resources[limit]=6`, {
          headers: { Accept: 'application/json' }
        });
        const json = await response.json();
        renderProducts(json.resources?.results?.products || [], cleanQuery);
      } catch {
        renderProducts([], cleanQuery);
      }
    };

    document.querySelectorAll('[data-search-open]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        if (button.hasAttribute('data-menu-close')) closeMenu();
        open();
      });
    });

    drawer.querySelectorAll('[data-search-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    input?.addEventListener('input', () => {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(() => fetchSuggestions(input.value), 180);
    });

    form?.addEventListener('submit', (event) => {
      const query = input?.value.trim();
      if (!query) {
        event.preventDefault();
        input?.focus();
      }
    });

    inlineForm?.addEventListener('submit', (event) => {
      const query = inlineInput?.value.trim();
      if (!query) {
        event.preventDefault();
        inlineInput?.focus();
      }
    });

    inlineForm?.querySelectorAll('[data-header-search-close]').forEach((button) => button.addEventListener('click', close));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });

    renderProducts([], '');
  };

  const initAliceCart = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    const body = drawer.querySelector('[data-cart-items]');
    const footer = drawer.querySelector('[data-cart-footer]');
    const subtotal = drawer.querySelector('[data-cart-subtotal]');
    const template = document.querySelector('[data-cart-item-template]');
    const cartLinks = document.querySelectorAll('[data-cart-open]');

    const open = () => {
      const searchDrawer = document.querySelector('[data-search-drawer]');
      searchDrawer?.classList.remove('is-open');
      searchDrawer?.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('theme-search-open');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cart-drawer-open');
    };

    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cart-drawer-open');
    };

    const updateCartLabels = (count) => {
      cartLinks.forEach((link) => {
        const base = 'CART';
        link.textContent = count > 0 ? `${base} (${count})` : base;
      });
    };

    const renderCart = (cart) => {
      updateCartLabels(cart.item_count || 0);
      if (subtotal) subtotal.textContent = moneyFormat(cart.total_price);
      if (footer) footer.hidden = !cart.items.length;
      if (!body || !template) return;

      body.innerHTML = '';

      if (!cart.items.length) {
        body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
        return;
      }

      cart.items.forEach((item, index) => {
        const node = template.content.firstElementChild.cloneNode(true);
        node.dataset.key = item.key;
        node.dataset.line = String(index + 1);

        const imageLink = node.querySelector('[data-cart-item-url]');
        const image = node.querySelector('[data-cart-item-image]');
        const title = node.querySelector('[data-cart-item-title]');
        const variant = node.querySelector('[data-cart-item-variant]');
        const quantity = node.querySelector('[data-cart-item-quantity]');
        const price = node.querySelector('[data-cart-item-price]');

        if (imageLink) imageLink.href = item.url;
        if (image && item.image) {
          image.src = item.image;
          image.alt = item.product_title || item.title || '';
        }
        if (title) {
          title.href = item.url;
          title.textContent = item.product_title || item.title;
        }
        if (variant) variant.textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        if (quantity) quantity.textContent = item.quantity;
        if (price) price.textContent = moneyFormat(item.final_line_price);

        body.appendChild(node);
      });
    };

    const fetchCart = async () => {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      renderCart(cart);
      return cart;
    };

    const showCartMessage = (message) => {
      if (body) body.innerHTML = `<p class="cart-drawer__empty">${escapeHtml(message)}</p>`;
      if (footer) footer.hidden = true;
      open();
    };

    const changeLine = async (key, quantity) => {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity })
      });
      renderCart(await response.json());
    };

    document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', close));

    cartLinks.forEach((link) => {
      link.addEventListener('click', async (event) => {
        event.preventDefault();
        await fetchCart();
        open();
      });
    });

    body?.addEventListener('click', async (event) => {
      const item = event.target.closest('[data-cart-item]');
      if (!item) return;
      const key = item.dataset.key;
      const current = Number(item.querySelector('[data-cart-item-quantity]')?.textContent || 1);

      if (event.target.closest('[data-cart-increase]')) {
        await changeLine(key, current + 1);
      }

      if (event.target.closest('[data-cart-decrease]')) {
        await changeLine(key, Math.max(current - 1, 0));
      }

      if (event.target.closest('[data-cart-remove]')) {
        await changeLine(key, 0);
      }
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        const submitter = event.submitter;
        const isBuyNow = submitter?.name === 'return_to' || submitter?.classList.contains('main-product__buy-now');
        event.preventDefault();
        form.classList.add('is-adding');
        submitter?.classList.add('is-adding');
        submitter?.setAttribute('aria-busy', 'true');

        const formData = new FormData(form);
        if (!formData.get('quantity')) formData.set('quantity', '1');

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
          });

          if (!response.ok) throw new Error('Unable to add item');

          if (isBuyNow) {
            window.location.href = '/checkout';
            return;
          }

          await fetchCart();
          open();
          submitter?.classList.add('is-added');
          window.setTimeout(() => submitter?.classList.remove('is-added'), 900);
        } catch {
          showCartMessage('We could not add this piece right now. Please try again.');
        } finally {
          form.classList.remove('is-adding');
          submitter?.classList.remove('is-adding');
          submitter?.removeAttribute('aria-busy');
        }
      });
    });

    fetchCart().catch(() => {});
  };

  const initAliceMotion = () => {
    document.documentElement.classList.add('alice-motion-ready');

    const motionSelectors = [
      '.alice-home__mosaic-tile',
      '.alice-home__section-header',
      '.alice-home__product-card',
      '.alice-home__campaign-panel',
      '.alice-home__campaign-copy',
      '.alice-home__ugc-card',
      '.alice-collection-card',
      '.alice-collection-editorial',
      '.alice-collection-story',
      '.main-product__media',
      '.main-product__summary',
      '.product-trust',
      '.site-footer__brand',
      '.site-footer__nav a',
      '.site-footer__contact > div',
      '.alice-info-page__hero',
      '.alice-info-page__panel',
      '.alice-info-page__card'
    ].join(',');

    const items = [...document.querySelectorAll(motionSelectors)];
    items.forEach((item, index) => {
      item.classList.add('alice-motion-item');
      item.style.setProperty('--alice-motion-index', String(index % 10));
    });

    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-in-view'));
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
      items.forEach((item) => observer.observe(item));
    }

    document.querySelectorAll('img[loading="lazy"], .alice-home__product-media img, .alice-collection-card__media img').forEach((image) => {
      image.classList.add('alice-lazy-image');
      if (image.complete) {
        image.classList.add('is-loaded');
      } else {
        image.addEventListener('load', () => image.classList.add('is-loaded'), { once: true });
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initAliceMenu();
    initAliceSearch();
    initAliceCart();
    initAliceMotion();
  });
})();
